export const customText = 'customText' //自定义内容